import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';
import { DasherBoardText, GoalVizEvent } from '~/core/enums';

import AdSlot from './components/adSlot/AdSlot';

import { DasherBoardContent, RinkAdContainer } from './styles';

type Props = {
    dasherBoardText?: DasherBoardText;
    eventId?: string | number;
    eventType?: GoalVizEvent;
    gameId: number;
    period?: number;
};

const ON_ICE_AD_SIZE: googletag.GeneralSize = [[200, 300]];
const BOARDS_AD_SIZE: googletag.GeneralSize = [[184, 69]];
const AdPos = { BOARDS_LEFT: '20', BOARDS_RIGHT: '21', ON_ICE_LEFT: '22', ON_ICE_RIGHT: '23' };

const RinkAds: FC<Props> = ({ dasherBoardText, eventId, eventType = GoalVizEvent.DEFAULT, gameId, period }) => {
    const theme = useTheme();
    const hasRequiredAdTargets = !!(period && eventId && eventType);
    return (
        <>
            {/*dasher boards*/}
            {dasherBoardText && (
                <g>
                    <rect x="600" y="-102" width="1200" height="102" fill={theme.Surface.primary} />
                    <rect x="600" y="-10" width="1200" height="10" fill="#FFF500" />

                    {/*left blue line*/}
                    <rect x="888" y="-102" fill={theme.Utility.blueLine} width="12" height="102" />

                    {/*right blue line*/}
                    <rect x="1500" y="-102" fill={theme.Utility.blueLine} width="12" height="102" />

                    {/*dasher top*/}
                    <rect x="600" y="-102" fill={theme.Utility.redLine} width="1200" height="6" />

                    {/*left dasher ad*/}
                    <foreignObject x="672" y="-87" width="184" height="72">
                        <RinkAdContainer>
                            {hasRequiredAdTargets && (
                                <AdSlot
                                    size={BOARDS_AD_SIZE}
                                    pos={AdPos.BOARDS_LEFT}
                                    gameId={gameId}
                                    period={period}
                                    eventType={eventType}
                                    eventId={eventId}
                                />
                            )}
                        </RinkAdContainer>
                    </foreignObject>

                    {/*right dasher ad*/}
                    <foreignObject x="1544" y="-87" width="184" height="72">
                        <RinkAdContainer $isLeftAligned>
                            {hasRequiredAdTargets && (
                                <AdSlot
                                    size={BOARDS_AD_SIZE}
                                    pos={AdPos.BOARDS_RIGHT}
                                    gameId={gameId}
                                    period={period}
                                    eventType={eventType}
                                    eventId={eventId}
                                />
                            )}
                        </RinkAdContainer>
                    </foreignObject>

                    <DasherBoardContent x="900" y="-96" width="600" height="86">
                        <FormattedMessage
                            {...(dasherBoardText === DasherBoardText.POWERPLAY
                                ? commonMessages.gameSituationDescriptions.long[ShortCodeEnums.SituationCode.powerPlay]
                                : commonMessages.eventDescriptions.goal)}
                        />
                    </DasherBoardContent>
                </g>
            )}

            {/*on-ice ads*/}
            {hasRequiredAdTargets && (
                <g>
                    {/*left on-ice ad*/}
                    <foreignObject x="600" y="360" width="200" height="300">
                        <RinkAdContainer>
                            <AdSlot
                                size={ON_ICE_AD_SIZE}
                                pos={AdPos.ON_ICE_LEFT}
                                gameId={gameId}
                                period={period}
                                eventType={eventType}
                                eventId={eventId}
                            />
                        </RinkAdContainer>
                    </foreignObject>
                    {/*right on-ice ad*/}
                    <foreignObject x="1600" y="360" width="200" height="300">
                        <RinkAdContainer $isLeftAligned>
                            <AdSlot
                                size={ON_ICE_AD_SIZE}
                                pos={AdPos.ON_ICE_RIGHT}
                                gameId={gameId}
                                period={period}
                                eventType={eventType}
                                eventId={eventId}
                            />
                        </RinkAdContainer>
                    </foreignObject>
                </g>
            )}
        </>
    );
};

export default RinkAds;
